import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/Loader';

const DepartmentEdit = () => {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [color, setColor] = useState('#000000');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/departments/getByParam?id=${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => res.json())
      .then(data => {
        setName(data.name || '');
        setColor(data.color || '#000000');
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load department');
        setLoading(false);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    fetch(`${process.env.REACT_APP_API_URL}/api/departments?id=${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ name, color }),
    })
      .then(res => {
        setSaving(false);
        if (res.ok) {
          navigate('/departments');
        } else {
          res.json().then(data => setError(data.message || 'Failed to update department'));
        }
      })
      .catch(() => {
        setSaving(false);
        setError('Failed to update department');
      });
  };

  if (loading) return  <Loader />;

  return (
    <div className="container-fluid users-page" style={{ width: '70%' }}>
      <div className="breadcrumb-row">
        <span className="breadcrumb-main" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer', color: '#337ab7' }}>Dashboard</span>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-users">Users</span>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-staff">Staff</span>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-departments">Departments</span>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-edit">Edit</span>
      </div>
      <form onSubmit={handleSubmit} style={{ maxWidth: '100%', backgroundColor: '#F8F9FA' }}>
        <label className='users-overview-title' style={{ margin: 16 }}>Edit Department</label>

        <div className="form-group mb-3 col-6" style={{ gap: '40px', justifyContent: 'center', flexDirection: 'row', alignItems: 'center' }}>
          <span className='col-3 label-required' style={{ textAlign: 'right' }}>Name</span>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group mb-3 col-6" style={{ gap: '40px', justifyContent: 'center', flexDirection: 'row', alignItems: 'center' }}>
          <span className='col-3' style={{ textAlign: 'right' }}>Color</span>
          <input
            type="color"
            className="form-control"
            value={color}
            onChange={e => setColor(e.target.value)}
            style={{ height: 40, padding: 0, border: 'none', background: 'none' }}
          />
          <span style={{ marginLeft: 12 }}>{color}</span>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className='col-6' style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', marginTop: 32, padding: 24 }}>

          <button className="btn btn-add-color" type="submit" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DepartmentEdit; 